import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-derechos-mujer',
  templateUrl: './derechos-mujer.component.html',
  styleUrls: ['./derechos-mujer.component.scss']
})
export class DerechosMujerComponent implements OnInit {

  constructor(private titleService: Title) {
    this.titleService.setTitle("DERECHOS DE LA MUJER");
  }

  ngOnInit(): void {
  }

  slides = [
    { id: "http://hdl.handle.net/20.500.14428/79295", img: "/assets/images/micrositio/micrositio20/MUJER-010.jpg", autor: "María Molinares de Reátegui. ", anno: "Carta a Zoila Aurora Cáceres.", anuNacimiento: "Lima, 20 de diciembre de 1930." },
    { id: "https://hdl.handle.net/20.500.14428/76522", img: "/assets/images/micrositio/micrositio20/MUJER-011.jpg", autor: "Zoila Aurora Cáceres. ", anno: "Carta a Antonia Camones. ", anuNacimiento: "Lima, 12 de enero de 1931." },
    { id: "https://hdl.handle.net/20.500.14428/64618", img: "/assets/images/micrositio/micrositio20/MUJER-012.jpg", autor: "Rosa Schrötter de Palacios. ", anno: "Carta a Zoila Aurora Cáceres. ", anuNacimiento: "Muquiyauyo, 2 de enero de 1931. " },
    { id: "https://hdl.handle.net/20.500.14428/63534", img: "/assets/images/micrositio/micrositio20/MUJER-013.jpg", autor: "José de la Riva Agüero y Osma.", anno: "Carta abierta a Zoila Aurora Cáceres. ", anuNacimiento: "Chorrillos, 11 de diciembre de 1930." },
    { id: "http://hdl.handle.net/20.500.14428/79305", img: "/assets/images/micrositio/micrositio20/MUJER-014.jpg", autor: "Luis Alberto Sánchez. ", anno: "Carta a Zoila Aurora Cáceres. ", anuNacimiento: "Lima, 31 de mayo de 1931." }
  ];

  slideConfig = {
    "slidesToShow": 5, "slidesToScroll": 1, "responsive": [
      {
        'breakpoint': 850,
        'settings': {
          'slidesToShow': 1
        }
      }
    ]
  };

}
